__turbopack_context__.v({
  "map": "Map-module-scss-module__KetCVG__map",
  "mapImg": "Map-module-scss-module__KetCVG__mapImg",
});
